<template>
    <Table
        :row-key="rowKey"
        border
        :columns="columns"
        :loading="loading"
        :data="tableData"
        :height="height"
        :highlight-row="true"
        @on-selection-change="onSelectChange"
        :load-data="isLoad ? handleLoadData : ''"
    >
        <!-- 单独使用 -->
        <template slot-scope="{ row }" slot="activeName">
            <span>{{ row.msg_title }}</span>
            &nbsp;
            <span class="iconfont ys-iconfujian" v-if="row.first_bk_fname"></span>
        </template>
        <!-- input输入 -->
        <template slot="inputs" slot-scope="{ row, index }">
            <Input
                placeholder="请输入"
                :type="row.type"
                size="small"
                :value="row.inputValue"
                @on-change="event => onInputChange(event, row, index)"
                @on-enter="event => onInputEnter(event, row, index)"
                style="width: 200px;border: none !important;border-bottom: 1px solid #dcdee2 !important;"
            />
        </template>
        <!-- switch开关 -->
        <template slot="tableSwitch" slot-scope="{ row }">
            <div v-for="(item, index) in columns" :key="index">
                <div v-if="item.Switchs" style="display: flex; flex-wrap: nowrap;">
                    <i-switch size="large" v-model="row.enabled" @on-change="SwitchChange($event, row.id)">
                        <span slot="open">启用</span>
                        <span slot="close">停用</span>
                    </i-switch>
                </div>
            </div>
        </template>
        <!-- 图标自定义 权限配置-->
        <template slot="iconfontconfig" slot-scope="{ row }">
            <div v-for="(item, index) in columns" :key="index">
                <div v-if="item.iconClassConfig" style="display: flex; flex-wrap: nowrap;">
                    <div v-for="(items, index) in item.iconClassConfig" :key="index">
                        <template v-if="hasPerm(items.Pname) == 2">
                            <span
                                :name="items.Pname"
                                :class="`imgStyle iconfont ${items.name}`"
                                @click="() => btnClick(items, row)"
                                v-if="items.status === 1"
                            ></span>
                            <Button :type="items.type" :size="items.size" @click="() => btnClick(items, row)" v-if="items.status === 2">
                                {{ items.name }}
                            </Button>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- 图标自定义 -->
        <template slot="iconfont" slot-scope="{ row }">
            <div v-for="(item, index) in columns" :key="index">
                <div v-if="item.iconClass" style="display: flex; flex-wrap: nowrap;">
                    <div v-for="(items, index) in item.iconClass" :key="index">
                        <template v-if="hasPerm(items.Pname) == 2">
                            <span
                                :class="`imgStyle iconfont ${items.name}`"
                                @click="() => btnClick(items, row)"
                                v-if="items.status === 1 && items.name !== 'ys-iconxin'"
                            ></span>
                            <span
                                :class="`imgStyle iconfont ${items.name}`"
                                @click="() => btnClick(items, row)"
                                v-if="items.status === 1 && items.name === 'ys-iconxin'"
                                :style="row.attent_yn_flag && row.attent_yn_flag === 1 ? 'color: #d81e06' : ''"
                            ></span>
                            <Button
                                :class="(item.type = 'text' ? 'ys-text' : '')"
                                :type="items.type"
                                :size="items.size"
                                @click="() => btnClick(items, row)"
                                v-if="items.status === 2"
                            >
                                {{ items.name }}
                            </Button>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- 里面是InputNumber -->
        <template slot="InputNumber" slot-scope="{ row, index }">
            <InputNumber
                :max="100"
                :min="1"
                :value="row.inputNumberValue ? row.inputNumberValue : 1"
                @on-change="event => onInputNumberChange(event, row, index)"
            />
        </template>
    </Table>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            height: 0,
        };
    },
    methods: {
        // 输入框值发生改变
        onInputChange(event, row, index) {
            this.$emit('on-input-change', row, index, event.target.value);
        },
        // enter事件
        onInputEnter(event, row, index) {
            this.$emit('on-input-enter', row, index, event.target.value);
        },
        // 选中的点击
        handleActive(row) {
            this.$emit('on-active-click', row);
        },
        // 自定义按钮点击
        btnClick(items, row) {
            this.$emit('on-btn-click', row, items);
        },
        // InputNumber变化后
        onInputNumberChange(event, row, index) {
            this.$emit('on-InputNumber-change', row, index, event);
        },
        // 表格选中
        onSelectChange(selection) {
            this.$emit('on-select-change', selection);
        },
        // switch改变事件
        SwitchChange(state, id) {
            this.$emit('switch-change', {
                state,
                id,
            });
        },
    },
    props: {
        // 传入的表头
        columns: {
            type: Array,
            required: true,
        },
        // 传入的数据
        tableData: {
            type: Array,
            required: true,
        },
        // 表格的高度
        tableHeight: {
            type: Number,
            required: true,
        },
        // 表格的高度
        rowKey: {
            type: String,
            default: 'id',
        },
        //是否需要懒加载
        isLoad: {
            type: Boolean,
            default: false,
        },
        //懒加载的事件
        handleLoadData: {
            type: Function,
            default: () => {},
        },
        // 加载动画
        loading: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        tableHeight: {
            immediate: true,
            handler(newValue, oldValue) {
                this.height = newValue;
            },
        },
    },
};
</script>
<style>
.ivu-table-cell {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.ivu-table-cell-tree {
    margin-right: 5px;
}

.active {
    color: #3485fb;
    cursor: pointer;
    text-decoration: underline;
}

.imgStyle {
    margin-right: 5px;
    cursor: pointer;
}

[type='reset'],
[type='submit'],
button,
html [type='button'] {
    margin-right: 5px;
}

.lock-off {
    background-image: url('../../../assets/images/lock-off.png');
    background-size: 100% 100%;
}

.lock-on {
    background-image: url('../../../assets/images/lock-on.png');
    background-size: 100% 100%;
}
.ivu-table-body {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
